// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation AddIntegrationEventMutation($input: AddIntegrationEventInput!) {
    addIntegrationEvent(input: $input) {
      integrationEventEdge {
        node {
          id
          originRule
          lambdaOnly
          lambdaId
          eventType {
            id
            name
            cosmeticName
          }
        }
      }
    }
  }
`;

export default {
  commit: (options: *) => {
    return createRelayMutation(mutation, {
      ...options,
      configs: [
        {
          type: 'RANGE_ADD',
          parentID: options.variables.input.integrationId,
          connectionInfo: [
            {
              key: 'Integration_events',
              rangeBehavior: 'prepend',
            },
          ],
          edgeName: 'integrationEventEdge',
        },
      ],
    });
  },
};
